import dotProp from 'dot-prop-immutable'
import update from 'immutability-helper'
import {
  CREATE_SECTION,
  LOAD_CATEGORY_SUCCESS,
  CREATE_LECTION,
  UPDATE_LOCATION_SECTION,
  UPDATE_LOCATION_LECTURE,
  APPEND_VIDEO_CREATE_COURSE,
  DETACH_VIDEO_CREATE_COURSE,
  UPDATE_COURSE_LANDING,
  UPDATE_COURSE_PRICING,
  UPDATE_ERROR_STATUS,
  UPDATE_FILE_LANDING,
  UPLOADING_FILE_COURSE,
  REMOVE_SECTION,
  REMOVE_LECTURE,
} from '../actions/types'

const updateCourseLanding = (state, action) => {
  const newState = dotProp.merge(state, 'courseLanding', { ...action.data.courseLanding })
  return newState
}

const appendFileToCourseLanding = (state, action) => {
  const file = action.data
  const [fileName] = Object.keys(file)
  file[fileName].uid = fileName
  const newState = dotProp.merge(state, `courseLanding.${fileName}`, file[fileName])
  return newState
}

const appendFileToStore = (state, action) => {
  const {
    indexLecture,
    indexSection,
    file,
    type,
  } = action.data
  const tempState = dotProp.merge(state, `course.sections.${indexSection}.lectures.${indexLecture}`, {
    fileUid: file.uid,
    filename: file.name,
    type,
  })
  const newState = dotProp.merge(tempState, `uploader.${indexSection}.lectures.${indexLecture}`, { file })
  return newState
}

const detachFileFromStore = (state, action) => {
  let {
    indexLecture,
    indexSection,
  } = action.data
  let tempState = dotProp.set(state, `course.sections.${indexSection}.lectures.${indexLecture}.fileUid`)
  tempState = dotProp.delete(tempState, `course.sections.${indexSection}.lectures.${indexLecture}.filename`)
  tempState = dotProp.delete(tempState, `course.sections.${indexSection}.lectures.${indexLecture}.type`)
  const newState = dotProp.delete(tempState, `uploader.${indexSection}.lectures.${indexLecture}`)
  return newState
}

const updateLocationOfSection = (state, action) => {
  const {
    data: {
      section,
    },
  } = action
  const newState = dotProp.set(state, 'course.sections', section)
  return newState
}

const updateLocationOfLecture = (state, action) => {
  const {
    sections,
  } = state
  const {
    data: {
      locationLecture: {
        currentSection,
        dragIndex,
        hoverIndex,
        nextSection,
      },
    },
  } = action
  if (currentSection !== nextSection) {
    // Get current section
    const { lectures } = sections[currentSection]
    const dragCard = lectures[dragIndex]
    const nextSectionMoving = dotProp.get(state, `sections.${nextSection}`)// Get next Section
    const { lectures: nextLecture } = nextSectionMoving

    // Update by adding current lecture to next section in lecture
    const updateNextSection = update(nextLecture, {
      $splice: [[dragIndex, 0], [hoverIndex, 0, dragCard]],
    })
    const updateStateForMovingNextSection = dotProp.set(state, `sections.${nextSection}.lectures`, updateNextSection)

    // Update by adding next section in lecture to current Section
    const newState = dotProp.delete(updateStateForMovingNextSection, `sections.${currentSection}.lectures.${dragIndex}`)
    return newState
  }
  const { lectures } = sections[currentSection]
  const dragCard = lectures[hoverIndex]
  const newSection = update(lectures, {
    $splice: [[hoverIndex, 1], [dragIndex, 0, dragCard]],
  })
  const newState = dotProp.set(state, `sections.${currentSection}.lectures`, newSection)
  return newState
}

const addSection = (state, action) => {
  const { title } = action.data
  const newState = dotProp.merge(state, 'course.sections', {
    title,
    lectures: [],
  })
  return newState
}

const removeSection = (state, action) => {
  const { indexSection } = action.data
  const newState = dotProp.delete(state, `course.sections.${indexSection}`)
  return newState
}

const addLecture = (state, action) => {
  const { index, title } = action.data
  const newState = dotProp.merge(state, `course.sections.${index}.lectures`, [{
    title,
  }])
  return newState
}

const removeLecture = (state, action) => {
  const { indexSection, indexLecture } = action.data
  const newState = dotProp.delete(state, `course.sections.${indexSection}.lectures.${indexLecture}`)
  return newState
}

const initialNewCourseState = {
  course: {
    levels: [],
    sections: [],
  },
  uploader: [],
  errorStatus: false,
  courseLanding: {},
  coursePrice: {},
}

const newCourse = (state = initialNewCourseState, action) => {
  switch (action.type) {
    case LOAD_CATEGORY_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case CREATE_SECTION:
      return addSection(state, action)
    case REMOVE_SECTION:
      return removeSection(state, action)
    case CREATE_LECTION:
      return addLecture(state, action)
    case REMOVE_LECTURE:
      return removeLecture(state, action)
    case UPDATE_LOCATION_SECTION:
      return updateLocationOfSection(state, action)
    case UPDATE_LOCATION_LECTURE:
      return updateLocationOfLecture(state, action)
    case APPEND_VIDEO_CREATE_COURSE:
      return appendFileToStore(state, action)
    case DETACH_VIDEO_CREATE_COURSE:
      return detachFileFromStore(state, action)
    case UPDATE_COURSE_LANDING:
      return updateCourseLanding(state, action)
    case UPDATE_FILE_LANDING:
      return appendFileToCourseLanding(state, action)
    case UPLOADING_FILE_COURSE:
      return {
        ...state,
        percent: action.data.percent,
      }
    case UPDATE_COURSE_PRICING:
      return {
        ...state,
        ...action.data,
      }
    case UPDATE_ERROR_STATUS:
      return {
        ...state,
        ...action.data,
      }
    default:
      return state
  }
}

export default newCourse



// WEBPACK FOOTER //
// ./src/reducers/newCourse.js